import { makeStyles } from '@material-ui/core'
import React, { FC } from 'react'

import { Typography } from '@popmenu/common-ui'

const useStyles = makeStyles({
  root: {
    fontStyle: 'italic',
  },
})

export const StepperActionsStatusText: FC<{
  statusText?: string
}> = (props) => {
  const { statusText } = props
  const classes = useStyles(props)
  return statusText ? (
    <Typography classes={{ root: classes.root }} variant="body2">
      {statusText}
    </Typography>
  ) : null
}
